import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiX, FiSend } from "react-icons/fi";

function ConsultationModal({ isOpen, onClose }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", service: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create email content
    const emailSubject = encodeURIComponent("Free Consultation Request - PD Marketz");
    const emailBody = encodeURIComponent(
      `Name: ${form.name}\n` +
      `Email: ${form.email}\n` +
      `Phone: ${form.phone}\n` +
      `Service: ${form.service}\n` +
      `Message: ${form.message}\n\n` +
      `---\n` +
      `This consultation request was submitted from the PD Marketz website.`
    );
    
    // Open email client
    window.location.href = `mailto:officialpdmarketz@gmail.com?subject=${emailSubject}&body=${emailBody}`;
    
    setSubmitted(true);
  };

  const handleClose = () => {
    onClose();
    setTimeout(() => {
      setSubmitted(false);
      setForm({ name: "", email: "", phone: "", service: "", message: "" });
    }, 400);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        /* Backdrop — covers full screen, flex centers the panel */
        <motion.div
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.22 }}
          onClick={handleClose}
        >
          {/* Panel — stop click propagation so clicking inside doesn't close */}
          <motion.div
            className="modal-box"
            role="dialog"
            aria-modal="true"
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.92 }}
            transition={{ duration: 0.24, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close — top right */}
            <button className="modal-close" onClick={handleClose} aria-label="Close">
              <FiX />
            </button>

            {submitted ? (
              <div className="modal-success">
                <span>✓</span>
                <h4>Thank You!</h4>
                <p>We've received your request and will get back to you within 24 hours.</p>
                <button className="modal-done-btn" onClick={handleClose}>Close</button>
              </div>
            ) : (
              <>
                <div className="modal-header">
                  <h3>Get Free Consultation</h3>
                  <p>Tell us about your business and we'll get back to you within 24 hours.</p>
                </div>

                <form className="modal-form" onSubmit={handleSubmit}>
                  <div className="modal-form-row">
                    <div className="modal-form-group">
                      <label htmlFor="m-name">Full Name *</label>
                      <input id="m-name" name="name" type="text" placeholder="Your name" value={form.name} onChange={handleChange} required />
                    </div>
                    <div className="modal-form-group">
                      <label htmlFor="m-email">Email Address *</label>
                      <input id="m-email" name="email" type="email" placeholder="your@email.com" value={form.email} onChange={handleChange} required />
                    </div>
                  </div>
                  <div className="modal-form-row">
                    <div className="modal-form-group">
                      <label htmlFor="m-phone">Phone Number</label>
                      <input id="m-phone" name="phone" type="tel" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={handleChange} />
                    </div>
                    <div className="modal-form-group">
                      <label htmlFor="m-service">Service Interested In</label>
                      <select id="m-service" name="service" value={form.service} onChange={handleChange}>
                        <option value="">Select a service</option>
                        <option>SEO Services</option>
                        <option>PPC Advertising</option>
                        <option>Social Media Marketing</option>
                        <option>Content Marketing</option>
                        <option>Email Marketing</option>
                        <option>Web Design &amp; Development</option>
                        <option>Ecommerce Services</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-form-group">
                    <label htmlFor="m-message">Message</label>
                    <textarea id="m-message" name="message" rows={4} placeholder="Tell us about your project…" value={form.message} onChange={handleChange} />
                  </div>
                  <button type="submit" className="modal-submit-btn">
                    Submit <FiSend />
                  </button>
                </form>
              </>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ConsultationModal;
